import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Mail } from "lucide-react";

const EXPLORE = [
  { to: "/yoga-retreats", label: "Yoga Retreats" },
  { to: "/wellness-retreats", label: "Wellness Retreats" },
  { to: "/yacht-retreats", label: "Yacht Retreats" },
  { to: "/yoga-sailing-retreats", label: "Yoga Sailing Retreats" },
  { to: "/retreats-for-beginners", label: "Beginner-Friendly" },
];

const COMPANY = [
  { to: "/about", label: "About" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/contact", label: "Contact" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms" },
  { to: "/affiliate-disclosure", label: "Affiliate Disclosure" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="mt-0 border-t border-brand-line bg-brand-bg2">
      <div className="mx-auto max-w-[1400px] px-6 py-16 md:px-10 md:py-24">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="overline text-brand-inkSoft">
              Yoga<span className="italic text-brand-terracotta">to</span>Yacht
            </p>
            <h3 className="mt-4 font-display text-3xl leading-tight text-brand-ink md:text-4xl">
              Find the escape that fits you.
            </h3>
            <p className="mt-5 max-w-md text-brand-inkSoft">
              A calm place to discover and compare Europe&apos;s best yoga, wellness, sailing and
              yacht retreats — by destination, budget and travel style.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a data-testid="footer-social-instagram" aria-label="Instagram" href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-brand-line bg-white text-brand-ink transition-colors hover:bg-brand-ink hover:text-white"><Instagram size={16} /></a>
              <a data-testid="footer-social-twitter" aria-label="Twitter" href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-brand-line bg-white text-brand-ink transition-colors hover:bg-brand-ink hover:text-white"><Twitter size={16} /></a>
              <a data-testid="footer-social-mail" aria-label="Email" href="mailto:hello@yogatoyacht.com" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-brand-line bg-white text-brand-ink transition-colors hover:bg-brand-ink hover:text-white"><Mail size={16} /></a>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="overline text-brand-inkSoft">Explore retreats</p>
            <ul className="mt-4 space-y-2 text-brand-ink">
              {EXPLORE.map((l) => (
                <li key={l.to}><Link data-testid={`footer-explore-${l.to.slice(1)}`} to={l.to} className="link-underline">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-brand-inkSoft">Company</p>
            <ul className="mt-4 space-y-2 text-brand-ink">
              {COMPANY.map((l) => (
                <li key={l.to}><Link data-testid={`footer-company-${l.to.slice(1)}`} to={l.to} className="link-underline">{l.label}</Link></li>
              ))}
              <li><a data-testid="footer-sitemap" href="/sitemap.xml" className="link-underline">Sitemap</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-brand-line pt-6 text-sm text-brand-inkSoft md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} YogaToYacht. Curated in Europe.</p>
          <p className="overline">Not a booking platform · We refer to partners</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
